
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Manubar from "./Manubar";
import Security from "./Security";
import Footer from "./Footer";
import Navbar from "./Navbar";
import axios from "axios";
import "./loader.css";
import "./Aboutus.css";

const Aboutus = () => {

  const [aboutus, setAboutus] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getAboutus() {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API}website/about_us`
      );

      setAboutus(res.data.data || []);
      setLoading(false);

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getAboutus();
  }, []);

  return (
    <div className="aboutus-page">

      {/* Mobile Menu */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      {/* Header */}
      <header>
        <Navbar />
      </header>

      {/* Breadcrumb */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center flex-wrap">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  About Us
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* About Section */}
      <section className="about-section section-mt section-mb">
        <div className="container">
          <div className="row justify-content-center">

          <div className="col-12 col-xl-10">

              <div className="about-content aboutus-content">

                {loading ? (

                  <div className="aboutus-loader-wrap">
                    <div className="loader"></div>
                  </div>

                ) : aboutus.length === 0 ? (

                  <p className="aboutus-empty">
                    No information available right now.
                  </p>

                ) : (

                  aboutus.map((item, idx) => (
                    <div key={idx} className="aboutus-block">
                      <h2 className="title aboutus-title">
                        {item?.title}
                      </h2>

                      <p className="aboutus-text text-start">
                        {item?.description}
                      </p>
                    </div>
                  ))

                )}

              </div>

            </div>

          </div>
        </div>
      </section>

      <Security />
      <Footer />

    </div>
  );
};

export default Aboutus;